import { render, staticRenderFns } from "./SerpulBills.vue?vue&type=template&id=514ee338&scoped=true&"
import script from "./SerpulBills.vue?vue&type=script&lang=js&"
export * from "./SerpulBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ee338",
  null
  
)

export default component.exports